import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';

import './index.css';

const ConsultationModal = ({ open, onClose }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        const form = new FormData();
        form.append("access_key", "b26dfc62-d651-46ca-b548-834806eaa7ea");
        form.append("subject", "New AI Consultation Request - Block Hash Pro");
        form.append("from_name", "Block Hash Pro Website");

        Object.keys(formData).forEach(key => {
            form.append(key, formData[key]);
        });

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: form
            });

            const data = await response.json();

            if (data.success) {
                toast.success("Thank you! We'll get back to you soon.", {
                    position: "top-right",
                    autoClose: 5000
                });
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    company: '',
                    message: ''
                });
                onClose();
            } else {
                toast.error("Something went wrong. Please try again.", {
                    position: "top-right",
                    autoClose: 5000
                });
            }
        } catch (error) {
            toast.error("Network error. Please check your connection.", {
                position: "top-right",
                autoClose: 5000
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            className="consultation-modal"
            PaperProps={{
                className: "consultation-modal-paper"
            }}
        >
            <DialogTitle className="consultation-modal-title">
                Get Free AI Consultation
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    className="consultation-modal-close"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className="consultation-modal-content">
                <p className="consultation-modal-subtitle">
                    Fill out the form below and our team will get back to you within 24 hours.
                </p>
                <form onSubmit={handleSubmit} className="consultation-form">
                    <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="John Doe"
                            required
                            disabled={isSubmitting}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="john@company.com"
                            required
                            disabled={isSubmitting}
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="+1 (234) 567-8900"
                                disabled={isSubmitting}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="company">Company Name</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder="Your Company"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">How can we help? *</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Tell us about your project or requirements..."
                            rows="4"
                            required
                            disabled={isSubmitting}
                        />
                    </div>
                    <button
                        type="submit"
                        className="consultation-submit-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <CircularProgress size={20} color="inherit" />
                                <span>Sending...</span>
                            </>
                        ) : (
                            'Send Message'
                        )}
                    </button>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ConsultationModal;
